import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["servicePrices", "servicePricesTemplate"];
  connect() {
    console.log("ServicePricesController connected");
  }

  addServicePrice(event) {
    event.preventDefault();
    console.log("addServicePrice method called");
    const template = this.servicePricesTemplateTarget.innerHTML.trim();
    this.servicePricesTarget.insertAdjacentHTML("beforeend", template);
  }

  removeServicePrice(event) {
    event.preventDefault();
    console.log("removeServicePrice method called");
    const servicePrice = event.target.closest(".service-price");
    servicePrice.remove();
  }

}
